module.exports = __webpack_public_path__ + "static/media/OVATO_WHITEPAPER_GERMAN.90515e90.pdf";